import { MFE_OVERRIDE_KEY, MFE_VARIANT_OVERRIDE_KEY } from "../mfe/mfeConfig";

export const setSessionStorage = <T>(key: string, value: T): void =>
  sessionStorage.setItem(key, JSON.stringify(value));

export const removeSessionStorage = (key: string): void =>
  sessionStorage.removeItem(key);

export const getSessionStorage = <T>(
  key: string,
  validator: (x: unknown) => x is T,
  fallback: T
) => {
  try {
    const x = JSON.parse(sessionStorage.getItem(key) ?? "null");
    return validator(x) ? x : fallback;
  } catch {
    return fallback;
  }
};

export const clearSessionStorage = (extraPersistKeys: string[]) => {
  const currentKeys: string[] = [];
  for (let index = 0; index < sessionStorage.length; index++) {
    const storageKey = sessionStorage.key(index);
    if (storageKey) {
      currentKeys.push(storageKey);
    }
  }

  const persistedKeys = [
    MFE_OVERRIDE_KEY,
    MFE_VARIANT_OVERRIDE_KEY,
    ...extraPersistKeys,
  ];

  currentKeys
    .filter((key) => !persistedKeys.includes(key))
    .forEach((key) => sessionStorage.removeItem(key));
};
